import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
`
const Line = styled.div`
  position: relative;
  flex: 1;
  &:before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0px;
    right: 0px;
    height: 1px;
    background-color: #e1e7ea;
  }
`
const Or = styled.div`
  font-size: 11px;
  line-height: 20px;
  font-weight: 500;
  color: #8da2b5;
  text-transform: uppercase;
  padding-left: 15px;
  padding-right: 15px;
`

class Separator extends Component {
  render () {
    return (
      <Container>
        <Line />
        <Or>Or</Or>
        <Line />
      </Container>
    )
  }
}

export default Separator



// WEBPACK FOOTER //
// ./src/components/signin/Separator.js